// extracted by mini-css-extract-plugin
export default {"sectionTitle":"_1-9Sv___Navigation-module__sectionTitle","navigation":"SNnwD___Navigation-module__navigation"};